import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogService} from '../../core/services/dialog.service';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-revoked-session',
  template: `<div></div>`
})
export class RevokedSessionComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  constructor(private dialog: DialogService, private router: Router) { }

  ngOnInit(): void {
    this. subscription = this.dialog.openAlertDialog(
      {
        title: 'Sessione revocata',
        content: `La tua sessione è stata automaticamente chiusa perché è stata avviata un’altra sessione
                  su un altro browser o dispositivo. Per continuare, effettua di nuovo il login.`
      },
      { disableClose: true }
    ).subscribe(() => {
      window.localStorage.removeItem('revoked');
      this.router.navigate(['/home']);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
